/**
 * 一般公開（研究デモ）モード。
 *
 * `VITE_PUBLIC_MODE=true`（frontend/.env）で有効。3D モールのフロアだけを見せ、
 * 商品・カート・マイページ・管理などの導線はすべて隠す。
 * 通常運用に戻すときは .env の値を false にするだけでよい。
 */

export const PUBLIC_MODE = import.meta.env.VITE_PUBLIC_MODE === "true";

/** 公開するフロア（＝空間 id）。エレベーターの行き先もこの並び順に従う */
export const PUBLIC_SPACE_IDS: number[] = (import.meta.env.VITE_PUBLIC_SPACE_IDS ?? "1,2,3,4")
  .split(",")
  .map((v: string) => Number(v.trim()))
  .filter((v: number) => Number.isFinite(v) && v > 0);

/** 公開モードでのトップページ（最初のフロア） */
export const PUBLIC_TOP_PATH = `/spaces/${PUBLIC_SPACE_IDS[0] ?? 1}`;

/** サイト名とフッタの表記 */
export const SITE_NAME = "TF-Mall";
export const COPYRIGHT = "Copyright © 2026 Technology Frontier Co., Ltd. All Rights Reserved.";
export const COMPANY_URL = "https://www.technologyfrontier.co.jp";

/** 公開してよいフロアか */
export function isPublicSpace(id: number | string | undefined): boolean {
  const n = Number(id);
  return Number.isFinite(n) && PUBLIC_SPACE_IDS.includes(n);
}
